import { FC } from 'react';
import { useRouteParams } from 'utils/useIdParam';
import { ROUTES } from 'config';
import { useAdminClient } from 'store/admin-clients';
import {
  AdminClientDepositsListPerClient,
  AdminClientDepositsListPerCompany,
} from './atoms';

export const AdminClientDepositsList: FC = () => {
  const { id: clientId } = useRouteParams(
    ROUTES.admin.clients.details.deposits.list,
  );

  const { data: client } = useAdminClient(clientId);

  if (!client) return null;

  return client.settings.depositManagementMethod === 'clientAccount' ? (
    <AdminClientDepositsListPerClient />
  ) : client.settings.depositManagementMethod === 'company' ? (
    <AdminClientDepositsListPerCompany />
  ) : null;
};
